import i18n from 'l10n';
import GenericView from 'js/views/generic.view';
import CreditsHistoryCollection from 'js/models/credits.history.paginated.collection';
import PaginatedView from 'js/views/pagination.view';
import Template from 'js/templates/credits.history.hbs';
import {el, on, tagName, template} from "../adapters/backbone-decorators";

require('jqueryUI');
require('metroHelpers');

@template(Template)
@tagName("span")
@el("#credit-history-container")
class CreditsHistoryView extends GenericView {

    delegateEvents(events) {
        this.cid = 'add-dialog';
        super.delegateEvents(events);
    }

    constructor() {
        super();
        this.collection = new CreditsHistoryCollection();
        // this.collection.on('sync', this.renderCollection, this);
        // this.collection.on('change', this.renderCollection, this);
        this.collection.on('all', this.renderCollection, this);
        this.loadCreditsHistory();
    }

    render() {
        super.render();
    }

    renderCollection() {
        var tempTemplate = this.template({collection: this.collection.data});
        this.$el.html(tempTemplate);
        this.$('[data-i18n]').i18n();
        if (this.pagination) {
            this.pagination.remove();
        }
        // Render collection the 1st time
        this.pagination = new PaginatedView({collection: this.collection});
        this.pagination.render();
        // Replace view's pagination
        this.$('#pagination').html(this.pagination.$el);
    }

    loadCreditsHistory() {
        this.collection.getFirstPage();
        console.info("Fetching credits history");
    }

    @on('click .button-invoice')
    createPdfInvoice(event) {
        event.preventDefault();
        var id = parseInt(event.target.id);
        var invoiceData = this.collection.data;
        var invoice = $.grep(invoiceData, function (item) {
            return item.paymentId === id;
        })[0]; //get [0] since $.grep returns an Array
        if (invoice.invoiceHistory === null) {
            var self = this;
            var url = '/CampaignCloud/Invoice/CreateInvoice';
            $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                data: {
                    paymentId: invoice.paymentId
                }
            }).done(function (response) {
                console.info(response);
                if (response.status === "success") {
                    self.loadCreditsHistory();
                    window.open(`/CampaignCloud/Invoice/InvoiceExport?paymentId=${invoice.paymentId}`, '_blank');
                } else if (response.InvoiceDetails === 'false') {
                    $.Notify.error(i18n.t("credits.noinvoicedetailserrormessage"));
                }
            }).fail(function (response) {
                if (response.status === 401) {
                    $("#error-message").text(i18n.t("credits.servererror"));
                }
            });
        } else {
            window.open(`/CampaignCloud/Invoice/InvoiceExport?paymentId=${invoice.paymentId}`, '_blank');
        }
    }
}

export default CreditsHistoryView;
